module.exports = __webpack_public_path__ + "static/img/7.158ec34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/7.png
// module id = Jkj7
// module chunks = 0